import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, Divider, IconButton } from 'material-ui';
import ActionInfo from 'material-ui/svg-icons/action/info';

import { getStateTitle } from '../../../utils/textFormat';
import ConversationAvatar from './ConversationAvatar';
import { localize } from '../../../i18n';

const styles = {
  list: {
    backgroundColor: 'white',
    paddingTop: '16px',
    paddingBottom: '0px',
  },
  itemTitle: {
    fontWeight: 500,
  },
  notActiveItem: {
    fontWeight: 300,
  },
  room: {
    fontSize: 14,
    padding: '4px 0',
  },
};

const NewChatList = (props) => {
  const {
    reservations,
    onSelect,
    onInfoRequested,
    t,
  } = props;

  const renderItem = (reservation, index) => {
    const {
      attributes: {
        name,
        state,
        room,
        phone,
      },
    } = reservation;

    const hasPhone = phone && phone.length;

    const secondaryText = (
      <div>
        <span>{getStateTitle(state)}</span>, {' '}
        <span>{t('Room {room}', { room })}</span>
      </div>
    );

    const infoButton = (
      <IconButton onClick={() => onInfoRequested(reservation)}>
        <ActionInfo />
      </IconButton>
    );

    return (
      <Fragment key={reservation.id}>
        <ListItem
          leftAvatar={<ConversationAvatar name={name} />}
          primaryText={<span style={hasPhone ? styles.itemTitle : styles.notActiveItem}>{name}</span>}
          secondaryText={secondaryText}
          rightIconButton={infoButton}
          secondaryTextLines={1}
          onClick={() => onSelect(reservation)}
        />
        { (index !== reservations.length - 1) && <Divider inset /> }
      </Fragment>
    );
  };

  return (
    <List style={styles.list}>
      {reservations.map(renderItem)}
    </List>
  );
};

NewChatList.propTypes = {
  reservations: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func,
  onInfoRequested: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default localize(NewChatList);



// WEBPACK FOOTER //
// ./src/views/chat/components/NewChatList.js